export default __webpack_public_path__ + "outlaw_background-details.bda97b.svg";